import { render, staticRenderFns } from "./schoolRoom.vue?vue&type=template&id=11b32fc4&scoped=true&"
import script from "./schoolRoom.vue?vue&type=script&lang=js&"
export * from "./schoolRoom.vue?vue&type=script&lang=js&"
import style0 from "./schoolRoom.vue?vue&type=style&index=0&id=11b32fc4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11b32fc4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VContainer,VSelect})
